import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(null);

  const checkSession = useCallback(async () => {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data);
    } catch (_e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    if (res.data?.access_token) {
      try { localStorage.setItem('rr_access_token', res.data.access_token); } catch (_) {}
    }
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (_) {}
    try { localStorage.removeItem('rr_access_token'); } catch (_) {}
    setUser(false);
    window.location.assign('/login');
  };

  const hasPermission = (module, action = 'read') => {
    if (!user || user === false) return false;
    if (user.role === 'admin') return true;
    return !!user.permissions?.[module]?.[action];
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: checkSession, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
};
